import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  private apiCount = 0;
  loading$ = this.loadingSubject.asObservable();

  show() {
    if (this.apiCount === 0) {
      this.loadingSubject.next(true);
    }
    this.apiCount++;
  }

  hide() {
    this.apiCount--;
    if (this.apiCount === 0) {
      this.loadingSubject.next(false);
    }
  }
}
